export default "__VITE_ASSET__IxTFEKE3__"